/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type SteamWalletDeposit = {
    /**
     * Deposit ID
     */
    id?: string;
    /**
     * User ID
     */
    userId?: string;
    /**
     * Steam wallet code
     */
    walletCode?: string;
    /**
     * Deposit value in cents
     */
    value?: number | null;
    /**
     * Deposit status (0=Pending, 1=Accepted, 2=Declined)
     */
    status?: SteamWalletDeposit.status;
    createdAt?: string;
    updatedAt?: string;
};
export namespace SteamWalletDeposit {
    /**
     * Deposit status (0=Pending, 1=Accepted, 2=Declined)
     */
    export enum status {
        '_0' = 0,
        '_1' = 1,
        '_2' = 2,
    }
}

